// Touch devices only fire Turbo's hover prefetch at the moment of the tap. Start it on pointerdown instead, so
// the finger's ~100-200ms on the glass is already fetching (the wizard prefetch guard still cancels drafts).
// While a tapped link's visit (page or frame) is under way it shows a pressed state (.is-navigating).
const PRESSED = "is-navigating"

export function prefetchableLink(target, origin) {
  const link = target?.closest?.("a[href]")
  if (!link || link.target || link.hasAttribute("download")) return null
  if (link.dataset.turboPrefetch === "false" || link.dataset.turbo === "false" || link.dataset.turboMethod) return null

  try {
    return new URL(link.href).origin === origin ? link : null
  } catch {
    return null
  }
}

export function installTapPrefetch(doc = document, win = window) {
  doc.addEventListener("pointerdown", (event) => {
    if (event.pointerType === "mouse") return
    const link = prefetchableLink(event.target, win.location.origin)
    link?.dispatchEvent(new win.MouseEvent("mouseenter"))
  }, { capture: true, passive: true })

  doc.addEventListener("turbo:click", (event) => {
    // Native shells push a new screen at once; a pressed card would only linger in the back-swipe screenshot.
    if (doc.documentElement?.classList?.contains("turbo-native")) return
    const card = event.target?.closest?.("a[href]")
    card?.classList.add(PRESSED)
  })

  const release = () => doc.querySelectorAll(`.${PRESSED}`).forEach((el) => el.classList.remove(PRESSED))
  doc.addEventListener("turbo:load", release)
  doc.addEventListener("turbo:before-cache", release)
  // Frame-targeted links fire turbo:click too, but a frame load never fires turbo:load.
  doc.addEventListener("turbo:frame-load", release)
  doc.addEventListener("turbo:fetch-request-error", release)
  win.addEventListener("pageshow", release)
}
